import { render, staticRenderFns } from "./yygl.vue?vue&type=template&id=72b8dba9&"
import script from "./yygl.vue?vue&type=script&lang=js&"
export * from "./yygl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports